import React, { useEffect, useState } from 'react';
import { Box, Spinner, Text, useColorModeValue } from '@chakra-ui/react';
import { BackgroundBeams } from "../ui/background-beams.tsx";
import { Helmet } from 'react-helmet';

const resolvePublic = (p) => {
  const base =
    (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '';
  return `${base.replace(/\/$/, '')}/${p.replace(/^\//, '')}`;
};

const TRANSPARENT_CSS = `
:root, html, body, #root { background: transparent !important; }
*[style*="background:"] { background: transparent !important; }
*[style*="background-color:"] { background-color: transparent !important; }
body { margin: 0 !important; }
`;

const TermsAndConditions = () => {
  const [html, setHtml] = useState('');
  const [status, setStatus] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const textColor   = useColorModeValue("gray.900", "gray.100");
  const headingColor= useColorModeValue("gray.900", "white");
  const linkColor   = useColorModeValue("blue.700", "blue.300");

  const panelBg     = useColorModeValue("whiteAlpha.850", "blackAlpha.650");
  const panelBlur   = "6px";
  const dimOverlay  = useColorModeValue("blackAlpha.200", "blackAlpha.400");

  useEffect(() => {
    const url = resolvePublic('/terms.html');
    setStatus('loading');
    fetch(url, { cache: 'no-store' })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load ${url} (${res.status})`);
        return res.text();
      })
      .then((txt) => {
        setHtml(`<style>${TRANSPARENT_CSS}</style>` + txt);
        setStatus('done');
      })
      .catch((err) => {
        setErrorMsg(err.message || 'Failed to load terms.html');
        setStatus('error');
      });
  }, []);

  return (
    <Box position="relative" minHeight="100vh" overflow="visible">
      <Helmet><title>Terms and Conditions | Gemini Cyber Security</title></Helmet>

      <Box position="fixed" inset={0} zIndex={0} pointerEvents="none">
        <BackgroundBeams />
      </Box>
      <Box position="fixed" inset={0} zIndex={0} pointerEvents="none" bg={dimOverlay} />

      <Box
        position="relative"
        zIndex={1}
        maxW="900px"
        mx="auto"
        px={{ base: 4, md: 6 }}
        py={{ base: 8, md: 12 }}
        bg={panelBg}
        borderRadius="lg"
        boxShadow="xl"
        style={{ backdropFilter: `blur(${panelBlur})` }}
        sx={{
          color: textColor,
          'h1, h2, h3, h4': { color: headingColor, marginTop: '1.5rem' },
          p: { marginTop: '0.75rem', lineHeight: 1.9, fontSize: '1.02rem' },
          ul: { paddingLeft: '1.25rem', marginTop: '0.5rem' },
          li: { marginTop: '0.35rem' },
          a: { color: linkColor, textDecoration: 'underline' }
        }}
      >
        {status === 'loading' && (
          <Box display="flex" alignItems="center" gap={3}>
            <Spinner />
            <Text color={textColor}>Loading terms &amp; conditions…</Text>
          </Box>
        )}
        {status === 'error' && <Text color="red.400" fontWeight="medium">{errorMsg}</Text>}
        {status === 'done'  && <Box dangerouslySetInnerHTML={{ __html: html }} />}
      </Box>

      <Box h="10vh" />
    </Box>
  );
};

export default TermsAndConditions;
